module.exports = __webpack_public_path__ + "img/online-store.d47e91a2.png";